import axios, { AUTH_PREFIX } from 'src/clients/axios';
import {
  BusinessTypeGetRsData,
  BusinessTypePostRqData,
  BusinessTypePostRsData,
} from 'src/models/Client';

export function getUpgradeAccountBusinessType() {
  return axios.get<BusinessTypeGetRsData>(
    `${AUTH_PREFIX}/account/business-type`,
  );
}

export function postUpgradeAccountBusinessType(data: BusinessTypePostRqData) {
  return axios.post<BusinessTypePostRsData>(
    `${AUTH_PREFIX}/account/business-type`,
    data,
  );
}
